import { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';

class NavTabsSkeleton extends Component {
  constructor(props) {
    super(props);

    this.firstKey = (Object.keys(this.props.tabsDefinition) || [false])[0];
    this.state = {
      activeTab: (this.firstKey && this.props.tabsDefinition) && this.props.tabsDefinition[this.firstKey] && this.props.tabsDefinition[this.firstKey].id,
    };
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
    if (this.props.onSelectTab) {
      this.props.onSelectTab();
    }
  }

  render() {
    const { activeTab } = this.state;
    const { tabsDefinition } = this.props;
    return (
      <div className="mb-5">
        <Nav className="tabs-button">
          {Object.keys(tabsDefinition).map((key) => {
            const tab = tabsDefinition[key];
            return (
              <NavItem key={`tab-nav-item-${key}`}>
                <NavLink
                  key={`tab-nav-${key}`}
                  className={activeTab === tab.id ? 'active' : ''}
                  onClick={() => this.toggleTab(tab.id)}
                >
                  {tab.title}
                </NavLink>
              </NavItem>
            );
          })}
        </Nav>
        <TabContent activeTab={activeTab}>
          {Object.keys(tabsDefinition).map((key) => {
            const tab = tabsDefinition[key];
            return (
              <TabPane tabId={tab.id} key={`tab-pane-${key}`}>
                {activeTab === tab.id
                  ? (
                    <tab.component
                      id={tab.id}
                      tab={tab.id}
                      key={`tab-list-${key}`}
                    />
                  )
                  : <div key={`tab-loading-${key}`}>Cargando</div>}
              </TabPane>
            );
          })}
        </TabContent>
      </div>
    );
  }
}

NavTabsSkeleton.propTypes = {
  tabsDefinition: PropTypes.object,
  onSelectTab: PropTypes.func,
};

export default NavTabsSkeleton;
